import classNames from "classnames";
import Section from "../components/Section";
import PageBackground from "../components/PageBackground";
import ScrollReveal from "../components/ScrollReveal";
import platformBackground from '../assets/backgrounds/platform.jpg';
import userFlowBackground from '../assets/backgrounds/user_workflow.jpg';
import {BottomNavigator} from "../components/Navbar";
import {useTranslation} from "react-i18next";
import {buildLocalizedImagePath} from "../utils";

export const PlatformFlowCard = ({image, title, className}) => {
    const {t} = useTranslation();
    return (
        <div className={ classNames('PlatformFlowCard', className) }>
            <img className={'PlatformFlowCard__image'}
                 src={image}/>
            <div className={'PlatformFlowCard__title'}>
                {t(title)}
            </div>
        </div>
    )
}

const PlatformPage = ({embedded = false}) => {
    const {t, i18n} = useTranslation();
    const language = i18n.language;
    const marketplaceGraphic = buildLocalizedImagePath(language, 'platform/marketplace');
    const userGraphic1 = buildLocalizedImagePath(language, 'platform/user/1');
    const userGraphic2 = buildLocalizedImagePath(language, 'platform/user/2');
    const userGraphic3 = buildLocalizedImagePath(language, 'platform/user/3');
    const userGraphic4 = buildLocalizedImagePath(language, 'platform/user/4');

    return (
        <div className={'Page PlatformPage'}>
            <Section className={'MarketplaceSection'}
                     id={'overview'}
            >
                <PageBackground src={platformBackground}/>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'left'}>
                        {t('platform.heading')}
                    </ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={80} variant={'up'}>
                        {t('platform.title')}
                    </ScrollReveal>
                    {/* <h3>{t('platform.subtitle')}</h3> */}
                    <ScrollReveal as={'img'}
                                  src={marketplaceGraphic}
                                  className={'MarketplaceSection__graphic'}
                                  threshold={0.12}
                                  delay={140}
                                  variant={'scale'}
                    />
                    <ScrollReveal as={'p'} threshold={0.12} delay={180} variant={'right'}>
                        {t('platform.description_1')}
                        <br/>
                        <br/>{t('platform.description_2')}
                    </ScrollReveal>
                </div>
            </Section>

            <Section className={'UserWorkflowSection'}
                     id={'user-workflow'}
            >
                <PageBackground src={userFlowBackground}/>
                <div className={'SectionContainer'}>
                    <ScrollReveal as={'h2'} threshold={0.12} variant={'right'}>
                        {t('platform.heading')}
                    </ScrollReveal>
                    <ScrollReveal as={'h1'} threshold={0.12} delay={80} variant={'up'}>
                        {t('platform.user_workflow')}
                    </ScrollReveal>

                    <div className={'PlatformFlowCards'}>
                        <ScrollReveal threshold={0.12} delay={140} variant={'left'}>
                            <PlatformFlowCard image={userGraphic1}
                                              title={t('platform.user_workflow_card_1')}/>
                        </ScrollReveal>
                        <ScrollReveal threshold={0.12} delay={210} variant={'up'}>
                            <PlatformFlowCard image={userGraphic2}
                                              title={t('platform.user_workflow_card_2')}/>
                        </ScrollReveal>
                        <ScrollReveal threshold={0.12} delay={280} variant={'right'}>
                            <PlatformFlowCard image={userGraphic3}
                                              title={t('platform.user_workflow_card_3')}/>
                        </ScrollReveal>
                        <ScrollReveal threshold={0.12} delay={350} variant={'down'}>
                            <PlatformFlowCard image={userGraphic4}
                                              title={t('platform.user_workflow_card_4')}/>
                        </ScrollReveal>
                    </div>
                </div>
            </Section>

            {
                !embedded &&
                <BottomNavigator
                    prev={{
                        to: '/about',
                        title: t('navbar.about')
                    }}
                    next={{
                        to: '/components',
                        title: t('navbar.components')
                    }}/>
            }
        </div>
    )
};

export default PlatformPage;
